import { Card } from '../ui/card';

export const DashboardCard = ({ name, description, thumbnail, isActive = false }) => {
  return (
    <Card 
      className={`p-4 bg-white cursor-pointer transition-all hover:shadow-md ${
        isActive ? 'ring-2 ring-purple-500' : ''
      }`}
      data-testid={`dashboard-card-${name.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <h4 
        className={`text-sm font-medium mb-2 ${isActive ? 'text-purple-600' : 'text-slate-700'}`}
        data-testid="dashboard-card-title"
      >
        {name}
      </h4>
      <div 
        className="aspect-video bg-slate-100 rounded-lg overflow-hidden"
        data-testid="dashboard-card-preview"
      >
        {thumbnail ? (
          <img 
            src={thumbnail} 
            alt={name} 
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-slate-400 text-xs">
            Preview
          </div>
        )}
      </div>
    </Card>
  );
};

export default DashboardCard;
